import React from 'react'
import { connect } from 'react-redux'
import { FileDrop } from 'react-file-drop'
import KML from '../../../../../lib/api/kml'
import { collapseLeftToolbar } from '../../../../../action/left-toolbar-state-actions'
import { fetchChanges } from '../../../../../action/changes-last-called-actions'

class Import extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      kmlFile: null,
      loading: false,
      objectCount: '...',
      uploaded: false,
      uploadType: ''
    }
    this.fileInput = React.createRef()
  }

  setKml(e) {
    const kmlFile = e.target.files[0]
    if (kmlFile) {
      this.setState({
        kmlFile,
        uploadType: 'upload'
      }, () => {
        const data = new FormData(),
          { token } = this.props
        data.append('kmlFile', this.fileInput.current.files[0], this.fileInput.current.files[0].name)
        KML.importCount(data, token)
          .then(res => {
            this.setState({ objectCount: res.objectCount })
          })
          .catch(err => {
            console.warn(err)
          })
      })
    }
  }

  importKML() {
    const { kmlFile, uploadType } = this.state,
      { token, fetchChanges } = this.props
    if (!kmlFile) {
      return
    }
    this.setState({ loading: true })
    const data = new FormData()
    if (uploadType === 'drag') {
      data.append('kmlFile', kmlFile, kmlFile.name)
    } else if (uploadType === 'upload') {
      data.append('kmlFile', this.fileInput.current.files[0], this.fileInput.current.files[0].name)
    }
    KML.import(data, token)
      .then(res => {
        fetchChanges()
          .then(res => {
            this.setState({ loading: false, kmlFile: null, uploaded: true })
            setTimeout(() => {
              this.props.collapseLeftToolbar()
            }, 1000);
          })
          .catch(err => {
            console.error('Import failed:', err)
          })
      })
      .catch(err => {
        console.error('Error importing KML file:', err)
      })
  }

  fileDropOnChange(file, e) {
    e.preventDefault()
    e.stopPropagation()
    const kmlFile = file[0]
    if (kmlFile) {
      this.setState({
        kmlFile,
        uploadType: 'drag'
      },
        () => {
          const data = new FormData(),
            { token } = this.props
          data.append('kmlFile', kmlFile, kmlFile.name)
          KML.importCount(data, token)
            .then(res => {
              this.setState({ objectCount: res.objectCount })
            })
            .catch(err => {
              console.warn(err)
            })
        }
      )
    }
  }

  render() {
    const { kmlFile, objectCount, loading, uploaded } = this.state,
      { collapseLeftToolbar } = this.props,
      uploadStyles = {
        width: '60%',
        color: 'white',
        backgroundColor: kmlFile ? '#589500' : '#c1c0c0'
      },
      cancelStyles = {
        width: '30%',
        color: 'white',
        backgroundColor: '#4f4f4f'
      }

    return (
      <div className='imp-exp-content'>
        <div className='imp-exp-title'>Import A File</div>
        <p className='imp-exp-details'>
          Add map data from .KML, .KMZ, or .GPX files to this map. This may take a few minutes depending on file size and the speed of your internet connection.
        </p>
        <div style={{ height: !kmlFile ? '230px' : '' }}>
          {
            !kmlFile ? (<FileDrop style={{ height: '200px' }}
              onDrop={(file, e) => this.fileDropOnChange(file, e)}
            >
              <div className='file-drop-text'>
                <h2>Drop File Here</h2>
                <h3 style={{ marginBottom: '5px' }}>Or</h3>
                <button
                  className='horizontal-center'
                  onClick={() => { this.fileInput.current.click() }}
                  style={{
                    pointerEvents: 'all',
                    width: '50%',
                    margin: 0
                  }}>Select File</button>
              </div>
            </FileDrop >) :
              (<div style={{ textAlign: 'center' }}>
                <p style={{ fontSize: '20px', marginBottom: '20px' }}>
                  {!uploaded ? 'File to be uploaded:' : 'File upload Complete'}
                </p>
                <p style={{ fontSize: '20px', color: 'rgb(88,149,0)', marginBottom: '20px' }}>
                  {kmlFile.name}
                </p>
                <p style={{ fontSize: '12px', marginBottom: '20px' }}>
                  {`File Size: ${(kmlFile.size / 1024).toFixed(0)} KB`}
                </p>
              </div>)
          }
        </div>
        <div className='imp-exp-count'>
          {`TOTAL OBJECTS FOR IMPORT: ${objectCount}`}
        </div>
        <div className='imp-exp-inputs'>
          <button style={cancelStyles} onClick={collapseLeftToolbar}>CANCEL</button>
          <button style={uploadStyles} onClick={this.importKML.bind(this)}>UPLOAD FILE</button>
        </div>
        <div style={{ display: 'none' }}>
          <input type='file'
            accept='*.kml'
            onChange={this.setKml.bind(this)}
            ref={this.fileInput}></input>
        </div>
        {
          loading ? (<div className='dialog-loading-overlay'></div>) : null
        }
      </div>
    )
  }
}

const mapStateToProps = state => ({
  token: state.auth.token
})

const mapDispatchToProps = dispatch => ({
  fetchChanges: () => (dispatch(fetchChanges())),
  collapseLeftToolbar: () => dispatch(collapseLeftToolbar())
})

export default connect(mapStateToProps, mapDispatchToProps)(Import)